import {
  NgModule,
} from '@angular/core';
import {
  RouterModule,
  Routes,
} from '@angular/router';
import {
  O3rOnNavigationPreloadingStrategy,
} from '@o3r/routing';
import {
  AppRoutes,
  sharedPageIds,
  SharedRoutes,
} from '../configuration/routes';

const appRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        redirectTo: AppRoutes.selfReaccommodation,
        pathMatch: 'full'
      },
      {
        path: AppRoutes.selfReaccommodation,
        loadChildren: () => import('./self-reaccommodation/index').then((m) => m.SelfReaccommodationModule)
      },
      {
        path: AppRoutes.refund,
        loadChildren: () => import('./refund/index').then((m) => m.RefundModule)
      },
      {
        path: SharedRoutes.recovery,
        loadChildren: () => import('./shared/recovery/index').then((m) => m.RecoveryModule),
        data: {
          title: 'refx-title.recovery',
          id: sharedPageIds.recovery
        }
      },
      {
        path: SharedRoutes.challenge,
        loadChildren: () => import('./shared/challenge/index').then((m) => m.ChallengeModule),
        data: {
          title: 'refx-title.challenge',
          id: sharedPageIds.recovery
        }
      },
      {
        path: '**',
        redirectTo: AppRoutes.selfReaccommodation,
        pathMatch: 'full'
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, {
    preloadingStrategy: O3rOnNavigationPreloadingStrategy,
    scrollPositionRestoration: 'top',
    onSameUrlNavigation: 'reload'
  })],
  providers: [O3rOnNavigationPreloadingStrategy],
  exports: [RouterModule]
})
export class AppRoutingModule {}
